import { render } from "./RFIManagement.vue?vue&type=template&id=5105bf55&scoped=true"
import script from "./RFIManagement.vue?vue&type=script&lang=js"
export * from "./RFIManagement.vue?vue&type=script&lang=js"

import "./RFIManagement.vue?vue&type=style&index=0&id=5105bf55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5105bf55"]])

export default __exports__